import { List } from 'immutable';
import {
    Component,
    OnInit,
    Input,
    ViewChild
} from '@angular/core';

import {
    BaseEntity,
    BaseInlineContainer,
    InlineContainerService,
    UserService
} from 'yt-ng-framework';

import { ActivatedRoute } from '@angular/router';
import { EPrijemnicaOpasnaMaterija } from './eprijemnica-opasna-materija';

@Component({
    selector: 'yt-eprijemnica-opasna-materija-update-container',
    templateUrl: './eprijemnica-opasna-materija-update-container.component.html',
    providers: [
        InlineContainerService
    ]
})
export class EPrijemnicaOpasnaMaterijaUpdateContainer<T extends BaseEntity>
    extends BaseInlineContainer<T>
    implements OnInit {
    @Input() Level: 'document' | 'item' | 'attribute' = 'document';

    @ViewChild("baseDetailList", { static: false })
    baseDetailList: any;

    tempItems: List<T>;

    constructor(
        inlineContainerService: InlineContainerService<T>,
        activatedRoute: ActivatedRoute,
        userService: UserService
    ) {
        super(inlineContainerService, activatedRoute, userService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngAfterViewInit() {
        if (this.baseDetailList && this.baseDetailList.tableConfig) {

            // Isključi nepotrebne akcione dugmiće u tabeli
            this.baseDetailList.tableConfig.ShowCheckBoxes = false;
            this.baseDetailList.tableConfig.DefaultListButtonsConfig.AddButtonConfig = false;
            this.baseDetailList.tableConfig.DefaultListButtonsConfig.DeleteAllButtonConfig = false;
            this.baseDetailList.tableConfig.DefaultListButtonsConfig.PrintButtonConfig = false;
            this.baseDetailList.tableConfig.DeleteIcon.Visible = false;
        }
    }
}
